import { SET_QUOTELIST } from '../../actions';

const quotelist = (state = [], action) => {
  switch (action.type) {
	case SET_QUOTELIST:
      return [...action.value];
    default: return state;
  }
}

export default quotelist;
